
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const Frost = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="Frost" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M15.5 4.5v-1h-1v1h-1.571a1.965 1.965 0 00-.212-.51l1.465-1.465-.707-.707-1.466 1.465a1.959 1.959 0 00-.509-.212V1.5h1v-1h-1V0h-1v.5h-1v1h1v1.571a1.994 1.994 0 00-.509.212L8.526 1.818l-.707.707L9.284 3.99a1.934 1.934 0 00-.213.51H6v1h3.07a1.965 1.965 0 00.212.51L6.01 9.284a1.934 1.934 0 00-.51-.213V6h-1v3.071l-.509.212-1.465-1.465-.707.707L3.284 9.99a1.934 1.934 0 00-.213.51H1.5v-1h-1v1H0v1h.5v1h1v-1h1.571a1.934 1.934 0 00.213.51L1.82 13.474l.707.707 1.464-1.464a1.959 1.959 0 00.509.212V14.5h-1v1h1v.5h1v-.5h1v-1h-1v-1.571a1.934 1.934 0 00.51-.213l1.466 1.466.707-.707-1.466-1.466a1.994 1.994 0 00.212-.509H10v-1H6.929a1.959 1.959 0 00-.212-.509l3.274-3.274a1.959 1.959 0 00.509.212V10h1V6.929a1.934 1.934 0 00.51-.213l1.467 1.466.707-.707-1.467-1.466a1.994 1.994 0 00.212-.509H14.5v1h1v-1h.5v-1zM5 12a1 1 0 111-1 1 1 0 01-1 1zm6-6a1 1 0 111-1 1 1 0 01-1 1z" />
</svg>
    </HvIconBase>
)};

Frost.propTypes = HvIconBase.propTypes;

export default Frost;